import React, { useState, useContext } from "react";
import Button from "../Button";
import { ArrowLoopIcon } from "myplan/components/Icon";
import { Container, Body, ArrowLoopContainer } from "./styles";
import { View, ViewStyle } from "react-native";
import { FurnitureContext } from "../../utils/furniture";

const message =
	"This quick exit takes you to safe mode (generic “stay organized” info). To get back to myPlan, close safe mode and restart the app.";

const SafeModeTooltip = () => {
	const [acknowledged, setAcknowledged] = useState(false);
	const furniture = useContext(FurnitureContext);
	if (acknowledged) return null;
	const onPress = () => {
		setAcknowledged(true);
	};
	let containerStyle: ViewStyle = {
		marginTop: 15,
		paddingHorizontal: 12,
	};
	return (
		<Container>
			<Body type="alert">
				{furniture?.strings?.homeLabelQuickExit || message}
			</Body>
			<View style={containerStyle}>
				<Button title={`OK`} onPress={onPress} />
			</View>
			<ArrowLoopContainer>
				<ArrowLoopIcon width="100%" height="100%" />
			</ArrowLoopContainer>
		</Container>
	);
};

export default SafeModeTooltip;
